import React from "react";
import styles from "./ActionButton.module.css";

export type ActionButtonVariant = "primary" | "secondary" | "danger" | "dangerOutline";

interface ActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /** Visual variant — defaults to "primary" */
    variant?: ActionButtonVariant;
    /** Optional icon (React element) placed before the label */
    icon?: React.ReactNode;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
    variant = "primary",
    icon,
    children,
    className,
    disabled,
    ...rest
}) => {
    const variantClass = styles[variant] ?? styles.primary;

    return (
        <button
            className={`${styles.btn} ${variantClass} ${disabled ? styles.disabled : ""} ${className ?? ""}`}
            disabled={disabled}
            {...rest}
        >
            {icon && icon}
            {children}
        </button>
    );
};
